import { useGtag } from "#imports";
import type { ConsentChoice } from "~~/app/utils/consent";

/**
 * GA4 consent helpers. Default state in nuxt.config.ts is "denied" for all
 * categories per Google Consent Mode v2. Call grantAnalytics() / grantAds()
 * after the user accepts cookies in a CMP (or denyAll() on revoke).
 *
 * Without a consent banner that calls grantAnalytics(), GA4 will only receive
 * cookieless modeled pings — no per-user data, no e-commerce attribution.
 */
export function useAnalyticsConsent() {
  const { gtag } = useGtag();

  function grantAnalytics() {
    gtag("consent", "update", {
      analytics_storage: "granted",
    });
  }

  function grantAds() {
    gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }

  function grantAll() {
    gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
  }

  function denyAll() {
    gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });
  }

  function setConsent(prefs: ConsentChoice) {
    gtag("consent", "update", {
      analytics_storage: prefs.analytics ? "granted" : "denied",
      ad_storage: prefs.marketing ? "granted" : "denied",
      ad_user_data: prefs.marketing ? "granted" : "denied",
      ad_personalization: prefs.marketing ? "granted" : "denied",
    });
  }

  return { grantAnalytics, grantAds, grantAll, denyAll, setConsent };
}
